import {WarehouseOverviewByProductsReport} from "../models/Report";
import {WarehouseOverviewByProductReportTemplateData} from "./WarehouseOverviewByProductReportTemplateData";
import {WarehouseOverviewByProductReportImportTemplate} from "./WarehouseOverviewByProductReportImportTemplate";
import {cloneDeep} from "lodash";

export const getWarehouseOverviewByProductReportTemplate = (
        reportData: WarehouseOverviewByProductsReport[],
        warehouseName: string,
        dateFrom: Date,
        dateTo: Date,
        productType: string,
        totalInputNeto: number,
        totalInputSrps: number,
        totalOutputNeto: number,
        totalOutputSrps: number,
    ) => {
    return WarehouseOverviewByProductReportImportTemplate(
        prepareData(
            reportData,
            warehouseName,
            dateFrom,
            dateTo,
            productType,
            totalInputNeto,
            totalInputSrps,
            totalOutputNeto,
            totalOutputSrps
        )
    );
};

const prepareData = (
        reportData: WarehouseOverviewByProductsReport[],
        warehouseName: string,
        dateFrom: Date,
        dateTo: Date,
        productType: string,
        totalInputNeto: number,
        totalInputSrps: number,
        totalOutputNeto: number,
        totalOutputSrps: number
    ) => {
    const templateData: WarehouseOverviewByProductReportTemplateData = {
        reportData: cloneDeep(reportData),
        warehouseName: warehouseName,
        dateFrom: dateFrom,
        dateTo: dateTo,
        productType: productType,
        totalInputNeto: totalInputNeto,
        totalInputSrps: totalInputSrps,
        totalOutputNeto: totalOutputNeto,
        totalOutputSrps: totalOutputSrps
    };

    return templateData;
};